import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient, HttpErrorResponse, } from '@angular/common/http';
import { User } from '../classes/user';
import { Router } from '@angular/router';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    isUserSigned = false;
    API_AUTH_URL = config.serverAddress + ':' + config.serverPort + '/auth/';
    @Output() userSignedIn = new EventEmitter<User>();
    @Output() userSignedOut = new EventEmitter();
    @Output() signInFailed = new EventEmitter();

    constructor(private http: HttpClient, private router: Router) { }

    isUserSignedIn() {
        return this.getToken() !== null && Date.now() < parseInt(this.getExpirationTime() || '0', 10);
    }

    signIn(user: User) {
        return this.http.post(this.API_AUTH_URL + 'login', user)
            .subscribe({
                next: (response: any) => {
                    localStorage.setItem('token', response.token);
                    localStorage.setItem('user', JSON.stringify(response.user));
                    localStorage.setItem('expirationTime', response.expirationTime);

                    const userSignedIn = new User();
                    userSignedIn.id_user = response.user.id_user;
                    userSignedIn.username = response.user.username;
                    this.userSignedIn.emit(userSignedIn);
                    this.router.navigate(['/inspection']);
                    return true;
                },
                error: (error: HttpErrorResponse) => {
                    console.log(error);
                    this.signInFailed.emit();
                }
            });
    }

    signOut() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('expirationTime');
        this.userSignedOut.emit();
        this.isUserSigned = false;
    }

    getUser(): User {
        const data = JSON.parse(localStorage.getItem('user') || '{}');
        const user = new User();
        if (data) {
            user.id_user = data.id_user;
            user.username = data.username;
            user.fk_id_role = data.fk_id_role;
            user.fk_id_pa = data.fk_id_pa;
        }
        return user;
    }

    getToken(): string | null {
        return localStorage.getItem('token');
    }

    getExpirationTime(): string | null {
        return localStorage.getItem('expirationTime');
    }
}
